import React from "react";
import CustomPopoverMui from "../../../../CustomPopoverMui/CustomPopoverMui";
import { Box, ListItemText, MenuItem } from "@material-ui/core";

const SelectPracticePopover = (props) => {
  const {
    popoverState,
    isPracticesOpen,
    handleClose,
    practiceSelected,
    changePracticeSelected,
    practicesListWithName,
  } = props;

  return (
    <CustomPopoverMui
      anchorEl={popoverState.anchorEl}
      handleClose={handleClose}
      open={isPracticesOpen}
      id={isPracticesOpen ? "simple-popover" : undefined}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          maxWidth: "280px",
          width: "100%",
          padding: "0.5rem",
        }}
      >
        <MenuItem
          style={{
            backgroundColor:
              practiceSelected === "All Practices" ? "#f0f5f0" : "transparent",
            borderRadius: practiceSelected === "All Practices" ? "8px" : "0",
            padding: "2px 16px",
          }}
          onClick={() => {
            handleClose();
            changePracticeSelected("All Practices");
          }}
        >
          <ListItemText primary="All Practices" />
        </MenuItem>
        {practicesListWithName?.practices?.map((practice) => (
          <MenuItem
            key={practice.name}
            onClick={() => {
              handleClose();
              changePracticeSelected(practice.name);
            }}
            style={{
              backgroundColor:
                practiceSelected === practice.name ? "#f0f5f0" : "transparent",
              borderRadius: practiceSelected === practice.name ? "8px" : "0",
              padding: "2px 16px",
            }}
          >
            <ListItemText primary={practice.name} />
          </MenuItem>
        ))}
      </Box>
    </CustomPopoverMui>
  );
};

export default SelectPracticePopover;
